// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const swablu: PokeData = {
  "id": 333,
  "name": "swablu",
  "height": 4,
  "weight": 12,
  "base_experience": 62,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "fury-attack",
    "take-down",
    "growl",
    "sing",
    "mist",
    "peck",
    "mirror-move",
    "perish-song",
    "safeguard",
    "dragon-breath",
    "refresh",
    "astonish",
    "natural-gift",
    "dragon-pulse",
    "round",
    "cotton-guard",
    "disarming-voice",
    "moonblast"
  ],
  "moves": [
    "growl",
    "peck",
    "dragon-breath",
    "refresh",
    "dragon-pulse",
    "moonblast",
    "brave-bird",
    "tailwind",
    "scary-face",
    "acrobatics",
    "tackle",
    "air-slash",
    "scratch"
  ],
  "evolution_chain": {
    "id": 168,
    "item": null,
    "species": [
      {
        "name": "swablu",
        "order": 361,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "altaria",
        "order": 362,
        "types": [
          PokeType.DRAGON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 333,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56.25,
    "speed": 50,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
